// import Vue from 'vue'
// import { BootstrapVue } from 'bootstrap-vue'
import VueI18n from 'vue-i18n'
import messages from '@/msg'
import _ from 'lodash'
window._ = _
import '@/libs/logger'
log.warn('iBlock start')

import App from '@/App.vue'
import store from '@/store'
import 'es6-promise/auto'

// import '@fortawesome/fontawesome-free/css/all.css'
// import '@fortawesome/fontawesome-free/js/all.js'

// Import Bootstrap an BootstrapVue CSS files (order is important)
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
// Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
// Vue.use(IconsPlugin)
// multi language
Vue.use(VueI18n)

Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: 'en',
  messages
})
window.i18n = i18n

new Vue({
  render: (h) => h(App),
  store,
  i18n
}).$mount('#app')
